export const BLUEBERRY_PAGE_UI = {
  vi: {
    loadingScene: "ĐANG TẢI CẢNH",
    loadingStory: "ĐANG TẢI CÂU CHUYỆN",
    trailerLabel: "XEM TRAILER",
    trailerAriaLabel: "Xem trailer",
    storyListLabel: "Các chương Blueberry Sensei",
    chapterAriaPrefix: "Chương",
    scrollUp: "Cuộn lên",
    scrollDown: "Cuộn xuống",
  },
  en: {
    loadingScene: "LOADING SCENE",
    loadingStory: "LOADING STORY",
    trailerLabel: "WATCH TRAILER",
    trailerAriaLabel: "Watch trailer",
    storyListLabel: "Blueberry Sensei chapters",
    chapterAriaPrefix: "Chapter",
    scrollUp: "Scroll up",
    scrollDown: "Scroll down",
  },
  ko: {
    loadingScene: "장면 불러오는 중",
    loadingStory: "이야기 불러오는 중",
    trailerLabel: "트레일러 보기",
    trailerAriaLabel: "트레일러 보기",
    storyListLabel: "Blueberry Sensei 챕터",
    chapterAriaPrefix: "장",
    scrollUp: "위로 스크롤",
    scrollDown: "아래로 스크롤",
  },
  ja: {
    loadingScene: "シーンを読み込み中",
    loadingStory: "物語を読み込み中",
    trailerLabel: "トレーラーを見る",
    trailerAriaLabel: "トレーラーを見る",
    storyListLabel: "Blueberry Sensei の章",
    chapterAriaPrefix: "章",
    scrollUp: "上にスクロール",
    scrollDown: "下にスクロール",
  },
  zh: {
    loadingScene: "正在加载场景",
    loadingStory: "正在加载故事",
    trailerLabel: "观看预告",
    trailerAriaLabel: "观看预告",
    storyListLabel: "Blueberry Sensei 章节",
    chapterAriaPrefix: "章节",
    scrollUp: "向上滚动",
    scrollDown: "向下滚动",
  },
};

export const BLUEBERRY_CHAPTER_META = {
  vi: [
    { id: "01", label: "Khởi Nguồn", sub: "Bi Kịch" },
    { id: "02", label: "Đại Ngưu", sub: "& Mất Mát" },
    { id: "03", label: "Đứa Trẻ", sub: "Ngỗ Nghịch" },
    { id: "04", label: "Thay Đổi", sub: "Ánh Sáng" },
    { id: "05", label: "Vụn Vỡ", sub: "20/05/2016" },
    { id: "06", label: "Sự Trừng Phạt", sub: "Lời Nguyền" },
    { id: "07", label: "Bi Ai", sub: "& Tàn Khốc" },
    { id: "08", label: "Về Phương Bắc", sub: "Độc Hành" },
  ],
  en: [
    { id: "01", label: "Origin", sub: "Tragedy" },
    { id: "02", label: "Dai Nguu", sub: "& Loss" },
    { id: "03", label: "The Child", sub: "Wayward" },
    { id: "04", label: "Turning", sub: "Light" },
    { id: "05", label: "Shattered", sub: "05/20/2016" },
    { id: "06", label: "Divine", sub: "Punishment" },
    { id: "07", label: "Sorrow", sub: "& Ruin" },
    { id: "08", label: "Northward", sub: "Alone" },
  ],
  ko: [
    { id: "01", label: "기원", sub: "비극" },
    { id: "02", label: "대우", sub: "상실" },
    { id: "03", label: "아이", sub: "비뚤어짐" },
    { id: "04", label: "변화", sub: "빛" },
    { id: "05", label: "붕괴", sub: "2016.05.20" },
    { id: "06", label: "신벌", sub: "저주" },
    { id: "07", label: "비애", sub: "파멸" },
    { id: "08", label: "북쪽으로", sub: "독행" },
  ],
  ja: [
    { id: "01", label: "起源", sub: "悲劇" },
    { id: "02", label: "大牛", sub: "喪失" },
    { id: "03", label: "子供", sub: "歪み" },
    { id: "04", label: "転機", sub: "光" },
    { id: "05", label: "崩壊", sub: "2016/05/20" },
    { id: "06", label: "神罰", sub: "呪い" },
    { id: "07", label: "悲哀", sub: "破滅" },
    { id: "08", label: "北へ", sub: "独行" },
  ],
  zh: [
    { id: "01", label: "起源", sub: "悲剧" },
    { id: "02", label: "大牛", sub: "与失去" },
    { id: "03", label: "孩子", sub: "乖戾" },
    { id: "04", label: "转折", sub: "微光" },
    { id: "05", label: "破碎", sub: "2016/05/20" },
    { id: "06", label: "神罚", sub: "诅咒" },
    { id: "07", label: "悲歌", sub: "毁灭" },
    { id: "08", label: "向北", sub: "独行" },
  ],
};

export const getBlueberryStoryMarkdownUrl = (lang) =>
  lang === "vi"
    ? "/about_blueberry_sensei/story.md"
    : `/about_blueberry_sensei/story.${lang}.md`;
